import { render, staticRenderFns } from "./WdmrOldData.vue?vue&type=template&id=13a15eae&"
import script from "./WdmrOldData.vue?vue&type=script&lang=js&"
export * from "./WdmrOldData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports